/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const ShoppingCart: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 4C0 3.44772 0.447715 3 1 3H3C3.43043 3 3.81257 3.27543 3.94868 3.68377L4.72076 6H22C22.3161 6 22.6136 6.14946 22.8023 6.40307C22.991 6.65668 23.0487 6.98457 22.9578 7.28735L19.9578 17.2873C19.8309 17.7103 19.4416 18 19 18H7C6.55839 18 6.16907 17.7103 6.04217 17.2873L3.04653 7.30185L2.27924 5H1C0.447715 5 0 4.55228 0 4ZM5.34403 8L7.74403 16H18.256L20.656 8H5.34403ZM9 20.5C9 21.3284 8.32843 22 7.5 22C6.67157 22 6 21.3284 6 20.5C6 19.6716 6.67157 19 7.5 19C8.32843 19 9 19.6716 9 20.5ZM18.5 22C19.3284 22 20 21.3284 20 20.5C20 19.6716 19.3284 19 18.5 19C17.6716 19 17 19.6716 17 20.5C17 21.3284 17.6716 22 18.5 22Z'
      fill='currentColor'
    />
  </React.Fragment>
)
